// Exchange rates are no longer fetched from API for security reasons
// All prices from backend already include markup and are in AUD
// This hook is kept for backwards compatibility but returns static fallback rates

import { FALLBACK_EXCHANGE_RATES } from '../utils/pricing';

function useExchangeRates(baseCurrency = 'AUD', fallbackRates = null) {
  // Return static rates from pricing utils - ensures consistent exchange rates
  const exchangeRates = fallbackRates || FALLBACK_EXCHANGE_RATES;
  
  return { 
    exchangeRates, 
    exchangeRatesLoading: false 
  };
}

export default useExchangeRates;